// extracted by mini-css-extract-plugin
export default {"markWrapper":"InstagramLogo_markWrapper__xLZjv"};